import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import { monthOptions, yearOptions } from "../../../config";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import moment from "moment";
import { tableConfigRO, tableConfigROYtd } from "./config";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import CardBartChart from "../../../../../../cards/SimpleBarchart";
import Api from "../../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import { HttpStatus } from "../../../../../common/Constants";

export default class ReportRO extends Component {
  constructor(props) {
    super(props);
    this.currentMonth = Number(moment().format("MM"));
    this.currentYear = Number(moment().format("YYYY"));
    this.state = {
      month: monthOptions.find((item) => item.value === this.currentMonth),
      year: yearOptions.find((item) => item.value === this.currentYear),
      dataTable: [],
      chartVisible: false,
      dataChart: [],
      dataKey: [],
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    const { type } = this.props;
    if (type === "ro") {
      // return this.fetchDataRO();
    }
    // return this.fetchDataROYTD();
  };

  fetchDataRO = async () => {
    const { setError, onTriggerLoading } = this.props;
    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT").find,
      setError: setError,
      menuName: "Dashboard CRM Kabeng Kacab - Monitoring RO Kabeng Kacab",
      args: null,
    });

    onTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: res.data.data,
      }));
    }
  };

  fetchDataROYTD = async () => {
    const { setError, onTriggerLoading } = this.props;
    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT").find,
      setError: setError,
      menuName: "Dashboard CRM Kabeng Kacab - Monitoring RO Kabeng Kacab YTD",
      args: null,
    });

    onTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: res.data.data,
      }));
    }
  };

  getTableColumns = () => {
    const { tab } = this.props;
    return tab === "RO" ? tableConfigRO : tableConfigROYtd;
  };

  handleChartVisibility = () => {
    this.setState((prev) => ({ ...prev, chartVisible: !prev.chartVisible }));
  };

  render() {
    const { tab } = this.props;
    const { month, year, dataTable, chartVisible, dataChart, dataKey } =
      this.state;
    return (
      <React.Fragment>
        <FlexView
          className="margin-top-15px margin-bottom-15px"
          style={{ gap: "20px" }}
        >
          {tab === "ro" && (
            <SimpleDDL
              id="select_options_bulan"
              box="search"
              name="month"
              containerclassname="width width-150px"
              placeholder="Bulan"
              options={monthOptions}
              value={month}
              onChange={(value, { name }) =>
                this.handleChangeValue(name, value)
              }
            />
          )}
          <SimpleDDL
            id="select_options_tahun"
            box="search"
            name="year"
            containerclassname="width width-150px"
            placeholder="Tahun"
            options={yearOptions}
            value={year}
            onChange={(value, { name }) => this.handleChangeValue(name, value)}
          />
          <SimpleButton
            id="btn_search"
            text="Cari"
            className="margin margin-top-5px"
            onClick={() => {}}
          />
        </FlexView>
        {chartVisible ? (
          <CardBartChart data={dataChart} dataKey={dataKey} />
        ) : (
          <SimpleDataTable
            data={dataTable}
            columns={this.getTableColumns()}
            options={{ pagination: false }}
            footerAdditionalButtons={
              <FlexView style={{ gap: "5px" }}>
                <SimpleButton id="btn_print" text="Cetak" onClick={() => {}} />
                {tab === "ytd" && (
                  <SimpleButton
                    id="btn_print"
                    text="Chart"
                    onClick={() => this.handleChartVisibility()}
                  />
                )}
              </FlexView>
            }
          />
        )}
        {tab === "ytd" && chartVisible && (
          <FlexView hAlignContent="right">
            <SimpleButton
              id="btn_print"
              text="Chart"
              onClick={() => this.handleChartVisibility()}
            />
          </FlexView>
        )}
      </React.Fragment>
    );
  }
}
